// Captures campaign tracking values from the landing URL (section 6.1 of the
// NPR Survey Intake API doc) and keeps them for the whole session so they
// survive the multi-step survey. No personal data is ever stored here.

const TRACKING_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "fbclid",
  // Meta dynamic URL parameters (?campaign_id={{campaign.id}}&adset_id=...&ad_id=...)
  "campaign_id",
  "adset_id",
  "ad_id",
];

const TRACKING_STORAGE_KEY = "nprTracking";
const SUBMISSION_ID_STORAGE_KEY = "nprSubmissionId";

const readSaved = () => {
  try {
    return JSON.parse(sessionStorage.getItem(TRACKING_STORAGE_KEY) || "{}");
  } catch {
    return {};
  }
};

// Call once when the landing page mounts. Safe to call repeatedly: values
// already saved are kept unless the URL carries a new value for the same key,
// and landing_page_url is only set the first time (the page they FIRST landed on).
export const captureTracking = () => {
  const saved = readSaved();
  const params = new URLSearchParams(window.location.search);

  TRACKING_KEYS.forEach((key) => {
    const value = params.get(key);
    if (value) saved[key] = value;
  });

  if (!saved.landing_page_url) {
    saved.landing_page_url = window.location.href.slice(0, 255);
  }

  try {
    sessionStorage.setItem(TRACKING_STORAGE_KEY, JSON.stringify(saved));
  } catch {
    // sessionStorage unavailable (private mode etc.) — tracking is optional
  }

  return saved;
};

export const getTracking = () => readSaved();

// One ID per submission. Reused if the same form is re-sent (e.g. network
// retry) so Salesforce can detect the duplicate and not create a second lead.
export const getSubmissionId = () => {
  try {
    let id = sessionStorage.getItem(SUBMISSION_ID_STORAGE_KEY);
    if (!id) {
      id = crypto.randomUUID
        ? crypto.randomUUID()
        : Date.now() + "-" + Math.random().toString(36).slice(2);
      sessionStorage.setItem(SUBMISSION_ID_STORAGE_KEY, id);
    }
    return id;
  } catch {
    // Storage blocked: still return a unique ID for this attempt
    return crypto.randomUUID
      ? crypto.randomUUID()
      : Date.now() + "-" + Math.random().toString(36).slice(2);
  }
};

// Call after a successful submit so the next candidate gets a new ID.
export const clearSubmissionId = () => {
  try {
    sessionStorage.removeItem(SUBMISSION_ID_STORAGE_KEY);
  } catch {
    /* ignore */
  }
};